<template>
  <LayoutSearchFieldVertical>
    <div
      class="search-field-last-update generated-3"
    >
      <UiButtonText
        class="search-field-last-update-text"
        v-for="(label, key) in LAST_UPDATE_TIMING_MAPPING"
        @click="setRange(key)"
      >
        {{ ls(label) }}
      </UiButtonText>
    </div>
  </LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import { LAST_UPDATE_TIMING_MAPPING } from '~/components/search/useSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { ls } = useI18n()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const setRange = (value: string) => {
  props.ss.setRange(props.field.key, [{ from: value, to: 'now' }])
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.search-field-last-update {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
    @include is-tablet {
      justify-content: space-between;
    }
}
.search-field-last-update-text {
    text-decoration-line: underline;
}
</style>
